module.exports = __webpack_public_path__ + "img/HG_16-9_30s.9726a500.jpg";